





























import Vue from 'vue';

import { Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Model, tabs } from '../../../models';
import { ActionTypes, GetterTypes } from '../../../store/types';

@Component
export default class extends Vue {
  public tabs = tabs;

  @Getter(GetterTypes.GET_CURRENT_TAB)
  public currentTab: string;

  @Getter(GetterTypes.GET_MODEL_CLASSIFICATION_SELECTED)
  public modelClassificationSelected: Model | null;

  @Getter(GetterTypes.GET_MODEL_EDIT_SELECTED)
  public modelEditSelected: Model | null;

  @Action(ActionTypes.UPDATE_MODEL_CLASSIFICATION_SELECTED)
  private setModelClassificationSelected: (model: Model | null) => void;

  @Action(ActionTypes.UPDATE_MODEL_EDIT_SELECTED)
  private setModelEditSelected: (model: Model | null) => void;


  @Action(ActionTypes.CLEAR_STORE)
  private clearStore: () => void;

  public destroyed() {
    this.clearStore();
  }
}
